import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Field, StringField, BooleanField, Int32Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class MacroModulatorBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new MacroModulatorBox({
            uuid,
            graph,
            name: "MacroModulatorBox",
            pointerRules: {
                accepts: [Pointers.Selection, Pointers.MetaData],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "MacroModulatorBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({ type: "modulator" });
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitMacroModulatorBox, this);
    }
    get tags() {
        return MacroModulatorBox.Tags;
    }
    get collection() {
        return this.getField(1);
    }
    get assignments() {
        return this.getField(2);
    }
    get label() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get index() {
        return this.getField(5);
    }
    get tracks() {
        return this.getField(6);
    }
    get bipolar() {
        return this.getField(7);
    }
    get amount() {
        return this.getField(8);
    }
    get value() {
        return this.getField(10);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "collection",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.ModulatorCollection, true),
            2: Field.hook({
                parent: this,
                fieldKey: 2,
                fieldName: "assignments",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.ModulatorSource],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: Int32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            6: Field.hook({
                parent: this,
                fieldKey: 6,
                fieldName: "tracks",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.TrackCollection],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            7: BooleanField.create({
                parent: this,
                fieldKey: 7,
                fieldName: "bipolar",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            8: Float32Field.create({
                parent: this,
                fieldKey: 8,
                fieldName: "amount",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.MIDIControl, Pointers.Automation],
                    mandatory: false,
                    exclusive: false,
                },
            }, "unipolar", "%", 1),
            10: Float32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "value",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.MIDIControl, Pointers.Automation],
                    mandatory: false,
                    exclusive: false,
                },
            }, "unipolar", "%", 0.5),
        };
    }
}
